import { RFIQuickLinks } from '../../../cimsPage/instances/rfi'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const object = 'Quick Link'
const page = RFIQuickLinks

const quickLinks = CreateViewEditSoftRemoveRestore({
  page,
  object,
  create: '15952ea1-38f6-43f0-91b6-f49cadd31be7',
  view: 'a74bf8f6-9b74-4e68-b5bd-b43a8fc6f607',
  edit: '8161f119-0568-48c6-9641-9dcdd5f99811',
  removeRestore: '5909d4b9-7058-4106-b850-8a1573a586d3',
})

export const CreateRFIQuickLink = quickLinks.Create
export const ViewRFIQuickLink = quickLinks.View
export const EditRFIQuickLink = quickLinks.Edit
export const RemoveRestoreRFIQuickLink = quickLinks.RemoveRestore

export type RFIQuickLinkPermission =
  | typeof CreateRFIQuickLink
  | typeof ViewRFIQuickLink
  | typeof EditRFIQuickLink
  | typeof RemoveRestoreRFIQuickLink
